import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetAPInotTrait = api.create('dponet', false)

const get = async ({ dataProcessTreatmentId = '', ...params }) => {
  return await dponetAPI.get(
    `data_process_treatments/${dataProcessTreatmentId}`,
    { params },
  )
}

const create = async ({ ...params }) => {
  return await dponetAPI.post(`data_process_treatments`, {
    dataProcessTreatment: params,
  })
}

const batchCreate = async ({ ...params }) => {
  return await dponetAPI.post(`data_process_treatments/batch`, {
    dataProcessTreatment: params,
  })
}

const changeStatus = async ({ dataProcessTreatmentId, ...params }) => {
  return await dponetAPI.patch(
    `data_process_treatments/${dataProcessTreatmentId}/change_status`,
    {
      dataProcessTreatment: params,
    },
  )
}

const stats = async ({ ...params }) => {
  return await dponetAPI.get(`data_process_treatments/stats`, {
    params,
  })
}

const responsibles = async () =>
  await dponetAPI.get(`data_process_treatments/responsibles`)

const createEvidencePlanAction = async ({
  dataProcessTreatmentId,
  ...params
}) => {
  return await dponetAPI.post(
    `data_process_treatments/${dataProcessTreatmentId}/evidence_plan_actions`,
    {
      evidencePlanAction: params,
    },
  )
}

const updateEvidencePlanAction = async ({
  dataProcessTreatmentId,
  evidencePlanActionId,
  ...params
}) => {
  return await dponetAPI.putForm(
    `data_process_treatments/${dataProcessTreatmentId}/evidence_plan_actions/${evidencePlanActionId}`,
    {
      evidencePlanAction: params,
    },
  )
}

const deleteEvidencePlanAction = async ({
  dataProcessTreatmentId,
  evidencePlanActionId,
}) => {
  return await dponetAPI.delete(
    `data_process_treatments/${dataProcessTreatmentId}/evidence_plan_actions/${evidencePlanActionId}`,
  )
}

const deleteEvidenceDocument = async ({
  dataProcessTreatmentId,
  evidencePlanActionId,
  documentId,
}) => {
  return await dponetAPI.delete(
    `data_process_treatments/${dataProcessTreatmentId}/evidence_plan_actions/${evidencePlanActionId}/document/${documentId}`,
  )
}

const generatePlanActions = async ({ dataProcessTreatmentId }) => {
  return await dponetAPInotTrait.post(
    `data_process_treatments/${dataProcessTreatmentId}/generate_plan_actions`,
  )
}

export default {
  batchCreate,
  changeStatus,
  create,
  createEvidencePlanAction,
  deleteEvidenceDocument,
  deleteEvidencePlanAction,
  generatePlanActions,
  get,
  responsibles,
  stats,
  updateEvidencePlanAction,
}
